export default function BackArrowIcon({ className="", onClick=null }) {
  return (
    <>
      <svg className={className} onClick={onClick} viewBox="0 0 17 26" xmlns="http://www.w3.org/2000/svg">
        <path d="m15.706 22.154c0.8302 0.7837 0.8335 2.0718 0.0075 2.8598-0.4174 0.3981-0.9633 0.5939-1.5097 0.5954-0.5464 0.0014-1.0933-0.1916-1.5126-0.5875l-9.6286-9.0892-3.0298-2.8601 3.0148-2.8677 9.581-9.1474c0.8346-0.78803 2.1836-0.79155 3.0223-0.00788 0.8302 0.7918 0.8335 2.0718 0.0075 2.868l-9.581 9.1474 9.6285 9.0893z"/>
      </svg>
    </>
  );
}